import React from "react";

const ImageIcon = props => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
    >
      <path
        d="M3.16663 11.4766L4.99742 9.14769C5.51656 8.48731 6.50964 8.4657 7.05702 9.10288L8.66663 10.9766M7.27666 9.35855C7.96809 8.479 8.93152 7.23293 8.9942 7.15186L9.00085 7.14334C9.52093 6.48721 10.5108 6.4671 11.057 7.10288L12.6666 8.97656M4.49996 3.97656H11.5C12.2363 3.97656 12.8333 4.57352 12.8333 5.3099V12.3099C12.8333 13.0463 12.2363 13.6432 11.5 13.6432H4.49996C3.76358 13.6432 3.16663 13.0463 3.16663 12.3099V5.3099C3.16663 4.57352 3.76358 3.97656 4.49996 3.97656Z"
        stroke="#64748B"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ImageIcon;
